import { useDrop } from 'react-dnd';

export type DraggableItem = {
  text: string;
};
interface DropItemProps {
  readonly children: React.ReactNode;
  readonly accept: string;
  readonly drop: (item: string) => void;
  readonly canDrop: boolean;
}

const DropItem = ({ children, accept, drop, canDrop }: DropItemProps) => {
  const [, dropRef] = useDrop(
    () => ({
      accept,
      disableDrop: !canDrop,
      canDrop: () => canDrop,
      drop: (item) => {
        const data = item as DraggableItem;
        if (canDrop) {
          drop(data.text);
        }
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [],
  );

  return <div ref={dropRef}>{children}</div>;
};

export default DropItem;
